<template>
  <div class="page">
    <home-header activeIndex="3" pageTitle="通知公告" />
    <div class="pageWrap">
      <div class="list">
        <div
          class="item"
          v-for="(item, idx) in noticeList"
          :key="idx"
          @click="toDetail(item.id)"
        >
          <img class="icon" :src="require('@/assets/notice.png')" alt="" />
          <div class="con">
            <div class="tit">[{{ item.nSource }}]{{ item.nTitle }}</div>
            <div class="time">{{ item.nCtime | dateFilter }}</div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          v-model="page"
          @change="onChangePage"
          :total="total"
          :page-size="size"
          show-less-items
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from "moment";
import { getNoticeList } from "@/api/notice";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";

export default {
  name: "notice",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      page: 1,
      size: 6,
      total: 0,
      noticeList: [],
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: id,
        },
      });
    },
    onChangePage(e) {
      this.getNotice(e);
    },
    getNotice(page) {
      getNoticeList({
        uvCode: localStorage.getItem("uvCode"),
        page: page,
        size: this.size,
      }).then((res) => {
        this.total = res.total;
        this.noticeList = res.rows;
      });
    },
  },
  mounted() {
    this.getNotice(this.page);
  },
};
</script>

<style lang="less" scoped>
.pageWrap {
  width: 1200px;
  background-color: #ffffff;
  border-radius: 4px;
  margin: 20px auto;
}
.list {
  min-height: 380px;
  .item {
    display: flex;
    align-items: center;
    padding: 0 32px;
    &:hover {
      background: #e8f3ff;
      cursor: pointer;
      .con {
        .tit {
          color: #2a79ff;
        }
      }
    }
    .icon {
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
    .con {
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #dedede;
      padding: 18px 0;
      width: calc(100% - 48px);
      .tit {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
      }
      .time {
        font-size: 14px;
        color: #999;
      }
    }
  }
}
.pagination {
  text-align: center;
  padding: 24px 0 32px;
  /deep/ .ant-pagination-item-active {
    background: #2a79ff;
    a {
      color: #fff;
    }
  }
}
</style>
